export const ROW_TYPE = {
  DATE: 'date',
  SELECT_OPTION: 'selectBox',
  RLOOKUP: 'rlookup',
  TIME: 'time',
  STRING: 'string',
  PRICE: 'price',
  SMALL_FLOAT: 'smallFloat',
  TEXT_AREA: 'textarea',
  CASH_BOX: 'cashBox',
  MOBILE: 'mobile',
  TELEPHONE: 'telephone',
  FILE: 'file',
  NUMBER: 'number',
  longNumber_2float: 'longNumber+2float',
  EDITOR: 'editor',

}
